<template>
  <data-table
    :data="items"
    :headers="headers"
    :loading="isLoading"
    :hide-table-bottom="true"
    :hide-delete="true"
    :hide-edit="true"
    no-items-text="Não encontrado na lista"
  />
</template>

<script>
import DataTable from '@/app/arch/components/data-table/DataTable.vue';

export default {
  name: 'CsnuList',
  components: { DataTable },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Primeiro nome',
        value: 'firstName',
      },
      {
        text: 'Segundo nome',
        value: 'secondName',
      },
      {
        text: 'Terceiro nome',
        value: 'thirdName',
      },
      {
        text: 'Nacionalidade',
        value: 'nationality',
      },
      {
        text: 'Apelido',
        value: 'aliasName',
      },
      {
        text: 'País',
        value: 'country',
      },
      {
        text: 'Cidade',
        value: 'city',
      },
    ],
  }),
  computed: {
    items() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
  },
};
</script>
